function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React, { useMemo } from 'react';
import Select from 'react-select';
import classNames from 'classnames';
import Async from './Async';
import Graph from './Graph';
import { useCustomField } from '../../../common/hooks/useCustomField';
import './index.scss';
export * from './Graph';
export * from './Async';

const AutoComplete = ({
  name,
  value,
  multiple,
  disabled,
  onChange,
  isValid,
  isInvalid,
  isTextbox,
  loading,
  options,
  filterOptions,
  ...props
}) => {
  const [customField, setCustomField] = useCustomField({
    name,
    value,
    onChange,
    multiple
  });

  const handleChange = data => {
    const value = Array.isArray(data) ? data.map(item => item.value) : data ? data.value : '';
    setCustomField(prev => ({ ...prev,
      value,
      dirty: true
    }));
  };

  const final = customField.value && (Array.isArray(customField.value) ? options.filter(item => customField.value.includes(item.value)) : options.find(item => item.value === customField.value));
  const extraProps = isTextbox ? {
    styles: {
      dropdownIndicator: () => ({
        display: 'none'
      }),
      indicatorSeparator: () => ({
        display: 'none'
      })
    },
    openMenuOnFocus: false,
    openMenuOnClick: false
  } : !multiple ? {
    styles: {
      indicatorSeparator: () => ({
        display: 'none'
      })
    }
  } : undefined;
  const filteredOptions = useMemo(() => filterOptions ? filterOptions(options) : options, [options, filterOptions]);
  return /*#__PURE__*/React.createElement(Select, _extends({
    className: classNames('auto-complete-select', {
      'is-valid': isValid,
      'is-invalid': isInvalid
    }),
    value: final,
    isMulti: multiple,
    isLoading: loading,
    isDisabled: disabled,
    onChange: handleChange,
    options: filteredOptions
  }, props, extraProps));
};

AutoComplete.Graph = Graph;
AutoComplete.Async = Async;
AutoComplete.defaultProps = {
  placeholder: '',
  multiple: true
};
export default AutoComplete;